export default "__VITE_ASSET__CNCTKkjU__"